// extracted by mini-css-extract-plugin
module.exports = {"teamSlider":"style_teamSlider__MyA7i","sliderButtonWrapper":"style_sliderButtonWrapper__AoUDq","sliderButton":"style_sliderButton__kCEoR"};